/**
 * NfceLocalRepository
 *
 * Abstrai o acesso às NFC-e armazenadas localmente via Electron IPC.
 */
import { getElectronAPI } from "@/plugins/desktop";

const NfceLocalRepository = {
  _api() {
    return getElectronAPI();
  },

  async salvar(nfce) {
    return this._api().nfce.salvar(nfce);
  },

  async getAll() {
    return this._api().nfce.getAll();
  },

  async getById(id) {
    return this._api().nfce.getById(id);
  },

  async getByUuid(uuid) {
    return this._api().nfce.getByUuid(uuid);
  },

  async listarPendentesSync() {
    return this._api().nfce.listarPendentesSync();
  },

  async listarPendentesFiscal() {
    return this._api().nfce.listarPendentesFiscal();
  },

  async listarComErroSync() {
    return this._api().nfce.listarComErroSync();
  },

  async marcarSincronizada(uuid) {
    return this._api().nfce.marcarSincronizada(uuid);
  },

  async marcarErroSync(uuid, erro) {
    return this._api().nfce.marcarErroSync(uuid, erro);
  },

  async atualizarStatusFiscal(uuid, status_fiscal, dados = {}) {
    return this._api().nfce.atualizarStatusFiscal(uuid, status_fiscal, dados);
  },

  async listarVendas(filtros = {}) {
    return this._api().nfce.listarVendas(filtros);
  },

  async cancelarLocal(uuid, motivo) {
    return this._api().nfce.cancelarLocal(uuid, motivo);
  },

  async cancelarPreVenda(uuid, motivo) {
    return this._api().nfce.cancelarPreVenda(uuid, motivo);
  },

  async cancelarFiscal(uuid, dados = {}) {
    return this._api().nfce.cancelarFiscal(uuid, dados);
  },

  /**
   * Aplica no banco local o status atualizado de uma NFC-e informado pelo back/web
   * (hoje, cancelamento). Localiza a venda por chave, uuid/id remoto ou
   * número/série/modelo/id_empresa.
   */
  async aplicarStatusRemoto(remoto = {}) {
    return this._api().nfce.aplicarStatusRemoto(remoto);
  },
};

export default NfceLocalRepository;
